package com.neurobs.ccab

import com.neurobs.util.Guid
import io.agora.media.RtcTokenBuilder
import io.agora.rtm.RtmTokenBuilder

/** Data for accessing Agora by a client
 *
 * @param rtcToken Token for logging into RTC
 * @param rtmToken Token for logging into RTM
 * @param channelName Unique GUID generated for each test station, used as the channel name for both RTC and RTM
 * @param userId Used as the User Id for both RTC and RTM. This is generated by AgoraUserId.
 */
case class AgoraTokenData
(
	appId: String,
	rtcToken: String,
	rtmToken: String,
	channelName: String,
	userId: String
)

class AgoraTokenGenerator (appId: String, appCertificate: String) {
	def generate(client: ChatClientId, existingChannelName: Option[String]): AgoraTokenData = {
		val channelName = existingChannelName.getOrElse(Guid.generate.noBracketsString)
		val userId = AgoraUserId.makeUserId(client)

		val rtcToken = (new RtcTokenBuilder).buildTokenWithUid(appId, appCertificate, channelName, 0, RtcTokenBuilder.Role.Role_Publisher, 0)

		val rtmToken = (new RtmTokenBuilder).buildToken(appId, appCertificate, userId, RtmTokenBuilder.Role.Rtm_User, 0)

		AgoraTokenData(appId = appId, rtcToken = rtcToken, rtmToken = rtmToken, channelName = channelName, userId = userId)
	}
}